// Leaderboard Management Admin Page
// Wrapper for the LeaderboardAdmin component

import React from 'react';
import LeaderboardAdmin from '../../components/admin/LeaderboardAdmin';

const LeaderboardManagement = () => {
  return <LeaderboardAdmin />;
};

export default LeaderboardManagement;
